module.exports = __webpack_public_path__ + "static/fx_1.69d24d7d.png";